<template>
	<div class="echats-con" v-show="shouldShowEcharts">
		<div ref="RefChart1" class="grid_line" style="width: 880px;height:145px;"></div>
		<div class="split-line"></div>
		<div class="heart-con">
			<div ref="RefChart2" class="grid_line" style="width: 880px;height:160px;"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'RoomLeftWaveformPanel',
	props: {
		shouldShowEcharts: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.split-line {
	width: 97%;
	position: absolute;
	top: 55.5%;
	left: 50%;
	transform: translate(-50%, -50%);
	height: 1px;
	background-image: linear-gradient(to right,
			#bfbfbf 0%,
			#bfbfbf 50%,
			transparent 50%);
	background-size: 10px 1px;
	background-repeat: repeat-x;
}

.grid_line {
	width: 100%;
	height: 100%;
	text-align: center;
	color: blue;
	box-sizing: border-box;
	border: 1px solid rgba(191, 191, 191, 0.1);
	background: -webkit-linear-gradient(top,
			transparent 15px,
			rgba(191, 191, 191, 0.1) 0),
		-webkit-linear-gradient(left, transparent 15px, rgba(191, 191, 191, 0.1) 0);
	background-size: 16px 16px;
}

.heart-con {
	position: relative;
}

.echats-con {
	padding-top: 60px;
	position: relative;
	flex: 1;
	width: 880px;
}
</style>
